import { NgModule } from '@angular/core';

import { RxntFormGroupDirective } from './rxnt-form-group.directive';

@NgModule({
  declarations: [
    RxntFormGroupDirective,
  ],
  exports: [
    RxntFormGroupDirective,
  ],
})
export class RxntFormGroupModule {
}
